<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Menuscript Details</li>
                <li></li>
            </ul>
            <h2 i18n>Menuscript Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-folder-open'></i>
                                    <span i18n>STATUS</span>
                                    <a >{{menuscript?.status}}</a>
                                </li>

                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>PUBLISHED DATE</span>
                                    <a>{{menuscript?.publish_date|date:'longDate'}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>MENUSCRIPT DATE</span>
                                    <a>{{menuscript?.menuscript_date|date:'longDate'}}</a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{menuscript?.title}}</h3>

                        <blockquote class="wp-block-quote">
                            <h3 i18n>Script</h3>
                            <p>
                                {{menuscript?.script}}
                            </p>
                        </blockquote>
                        
                        <h3 i18n>Description</h3>
                        <p> {{menuscript?.text}}</p>
                        
                        <ul class="wp-block-gallery columns-3">
                            <li class="blocks-gallery-item" *ngFor="let img of menuscript?.images">
                                <figure>
                                    <img [src]="imageURL+img.url" style="max-height:25em" alt="image">
                                </figure>
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>